var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33924 4H21.0177C21.7562 4 22.3569 4.60078 22.3569 5.33924C22.3569 6.0777 21.7562 6.67848 21.0177 6.67848H2.33924C1.60078 6.68266 1 6.08187 1 5.33924C1 4.60078 1.60078 4 2.33924 4Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33924 10.6628H14.2589C14.9974 10.6628 15.5982 11.2636 15.5982 12.0021C15.5982 12.7405 14.9974 13.3413 14.2589 13.3413H2.33924C1.60078 13.3413 1 12.7405 1 12.0021C1 11.2636 1.60078 10.6628 2.33924 10.6628Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33924 17.3215H7.50012C8.23858 17.3215 8.83936 17.9223 8.83936 18.6607C8.83936 19.3992 8.23858 20 7.50012 20H2.33924C1.60078 20.0041 1 19.4033 1 18.6649C1 17.9223 1.60078 17.3215 2.33924 17.3215Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.7559fecbd78f8d3522183d9b7a350077.svg";
export { ForwardRef as ReactComponent };